import * as THREE from "three";
import { perlin3 } from "./noise.js";

let sphere;
let previousSpikes = [];

function perlinBlob(scene, material) {
  const geometry = new THREE.SphereGeometry(16, 54, 54);
  sphere = new THREE.Mesh(geometry, material);
  sphere.position.set(0, 0.05, 0.25);
  scene.add(sphere);

  // Initialize previousSpikes array
  for (let i = 0; i < geometry.attributes.position.count; i++) {
    previousSpikes.push(0.75);
  }
}

function updatePerlinBlob(intersects) {
  if (!sphere || !sphere.geometry) {
    return;
  }

  const time = performance.now() * 0.0004;
  const positions = sphere.geometry.attributes.position;
  const baseSpikes = 0.75;
  const baseScaleFactor = 0.75;
  const maxScaleFactor = 3;
  const mouseRadius = 1.2;
  const lambda = 4; // Adjust lambda for smoothness
  const dt = 0.016; // 0.016 is the Approximate delta time for 60fps (1/60)

  for (let i = 0; i < positions.count; i++) {
    let x = positions.getX(i);
    let y = positions.getY(i);
    let z = positions.getZ(i);
    let p = new THREE.Vector3(x, y, z).normalize();

    // Calculate distance from the current vertex to the mouse intersection
    let distance = Infinity;
    if (intersects.length > 0) {
      const intersectPoint = intersects[0].point;
      distance = p.distanceTo(intersectPoint);
    }

    // Adjust the spikes factor based on distance to the intersection point
    let spikes = baseSpikes;
    if (distance < mouseRadius) {
      let distanceFactor = 1 - distance / mouseRadius;
      spikes = baseSpikes + (maxScaleFactor - baseSpikes) * distanceFactor;
    }

    // Smooth the transition using damp
    previousSpikes[i] = THREE.MathUtils.damp(
      previousSpikes[i],
      spikes,
      lambda,
      dt
    );

    // Calculate perlin noise-based scale
    let perlinValue = perlin3(
      p.x * previousSpikes[i] + time,
      p.y * previousSpikes[i],
      p.z * previousSpikes[i]
    );

    let finalScale = baseScaleFactor + 0.1 * perlinValue * previousSpikes[i];

    positions.setXYZ(i, p.x * finalScale, p.y * finalScale, p.z * finalScale);
  }

  positions.needsUpdate = true;
  sphere.geometry.computeVertexNormals();
}

export { perlinBlob, updatePerlinBlob };
